export default __webpack_public_path__ + "static/Jean Aristilde-76205d6f9371011cc755f5bdedaea164.png";